/** @format */

import React, { useState } from 'react';
import { Row, Column } from 'components/ui/Grid';
import { noop } from 'utils/functions/noop';
import PropTypes from 'prop-types';
import {
  Destinatari,
  Ente,
  InformazioniServizio,
  PersonaleEsterno,
  PersonaleInterno,
  Prezzo,
  PrimoContatto,
  SedeErogazione,
  Servizio,
  SliderImmagini,
  ButtonSalva,
} from './accordionPartials';


const AccordionServAcc = ({ Form = {}, ReadOnly, estraiDati = noop }) => {
  const [destinatari, setDestinatari] = useState(Form.destinatari);

  const [servizio, setServizio] = useState(Form.servizio);

  const [descrittoriDelBenessere] = useState(Form.descrittoriDelBenessere);

  const [sliderImmagini, setSliderImmagini] = useState(Form.sliderImmagini);

  const [sede, setSede] = useState(Form.sede);

  const [sostegni] = useState(Form.sostegni);

  const [personaleInterno, setPersonaleInterno] = useState(Form.personaleInterno);

  const [personaleEsterno, setPersonaleEsterno] = useState(Form.personaleEsterno);

  const [prezzo, setPrezzo] = useState(Form.prezzo);

  const informazioniMemo = React.useMemo(() => (
    <InformazioniServizio Form={Form.informazioni}></InformazioniServizio>
  ), [Form.informazioni]);


  const enteMemo = React.useMemo(() => (
    <Ente Form={Form.ente}></Ente>
  ), [Form.ente]);


  const destinatariMemo = React.useMemo(() => (
    <Destinatari
      Form={destinatari}
      SetForm={setDestinatari}
      Modifica={Form.modifica}
    >
    </Destinatari>
  ), [destinatari]);

  const primoContattoMemo = React.useMemo(() => (
    <PrimoContatto Form={Form.primoContatto}></PrimoContatto>
  ), [Form.primoContatto]);

  const servizioMemo = React.useMemo(() => (
    <Servizio
      Form={servizio}
      SetForm={setServizio}
      Modifica={Form.modifica}
    >
    </Servizio>
  ), [servizio]);

  const sliderImmaginiMemo = React.useMemo(() => (
    <SliderImmagini
      Form={sliderImmagini}
      SetForm={setSliderImmagini}
      Modifica={Form.modifica}
    />
  ), [sliderImmagini]);

  const sedeMemo = React.useMemo(() => (
    <SedeErogazione
      Form={sede}
      SetForm={setSede}
      Modifica={Form.modifica}
    >
    </SedeErogazione>
  ), [sede]);

  const prezzoMemo = React.useMemo(() => (
    <Prezzo
      Form={prezzo}
      SetForm={setPrezzo}
      Modifica={Form.modifica}
    >
    </Prezzo>
  ), [prezzo]);

  const internoMemo = React.useMemo(() => (
    <PersonaleInterno
      Form={personaleInterno}
      SetForm={setPersonaleInterno}
      Modifica={Form.modifica}
    >
    </PersonaleInterno>
  ), [personaleInterno]);

  const esternoMemo = React.useMemo(() => (
    <PersonaleEsterno
      Form={personaleEsterno}
      SetForm={setPersonaleEsterno}
      Modifica={Form.modifica}
    >
    </PersonaleEsterno>
  ), [personaleEsterno]);

  const subForms = [
    informazioniMemo,
    enteMemo,
    destinatariMemo,
    primoContattoMemo,
    servizioMemo,
    sliderImmaginiMemo,
    sedeMemo,
    internoMemo,
    esternoMemo,
    prezzoMemo,
  ];

  const newForm = {
    ...Form,
    destinatari,
    servizio,
    descrittoriDelBenessere,
    sliderImmagini,
    sede,
    sostegni,
    personaleInterno,
    personaleEsterno,
    prezzo,
  };

  return (
    <Row fluid>
      {
        subForms.map((subform, index) => (
          <Column xs="12" key={`subForms-${index.toString}`}>
            {subform}
          </Column>
        ))
      }
      <ButtonSalva
        StartForm={Form}
        Form={newForm}
        ReadOnly={ReadOnly}
        estraiDati={estraiDati}
      />
    </Row>
  );
};

const ModificaShape = PropTypes.shape({
  campi: PropTypes.bool.isRequired,
  note: PropTypes.bool.isRequired,
});

const DestinatariShape = PropTypes.shape({
  attivo: PropTypes.bool,
  lista: PropTypes.arrayOf(PropTypes.string),
});

const ServizioShape = PropTypes.shape({
  id: PropTypes.string,
  nome: PropTypes.string,
});

const DescrittoriDelBenessereShape = PropTypes.arrayOf(PropTypes.string);

const SliderImmaginiShape = PropTypes.shape({
  immagini: PropTypes.arrayOf(
    PropTypes.shape({
      descrizione: PropTypes.string,
      url: PropTypes.string.isRequired,
    })
  ),
});

const SedeShape = PropTypes.shape({
  cap: PropTypes.string,
  citta: PropTypes.string,
  indirizzo: PropTypes.string,
});

const SostegniShape = PropTypes.arrayOf(
  PropTypes.shape({
    tipo: PropTypes.string,
    valore: PropTypes.number,
  })
);

const PersonaleShape = PropTypes.shape({
  contatto: PropTypes.string,
  nome: PropTypes.string,
  ruolo: PropTypes.string,
});

const PrezzoShape = PropTypes.shape({
  importo: PropTypes.number,
  valuta: PropTypes.string,
});

const InformazioniServizioShape = PropTypes.shape({
  descrizione: PropTypes.string,
  durata: PropTypes.string,
});

const EnteShape = PropTypes.shape({
  codice: PropTypes.string,
  nome: PropTypes.string,
});

const PrimoContattoShape = PropTypes.shape({
  email: PropTypes.string,
  nome: PropTypes.string,
  telefono: PropTypes.string,
});

AccordionServAcc.propTypes = {
  estraiDati: PropTypes.func,
  Form: PropTypes.shape({
    descrittoriDelBenessere: DescrittoriDelBenessereShape,
    destinatari: DestinatariShape,
    ente: EnteShape,
    informazioni: InformazioniServizioShape,
    modifica: ModificaShape,
    personaleEsterno: PersonaleShape,
    personaleInterno: PersonaleShape,
    prezzo: PrezzoShape,
    primoContatto: PrimoContattoShape,
    sede: SedeShape,
    servizio: ServizioShape,
    sliderImmagini: SliderImmaginiShape,
    sostegni: SostegniShape,
  }),
  ReadOnly: PropTypes.bool.isRequired,
};

AccordionServAcc.defaultProps = {
  Form: {},
  estraiDati: () => {},
};


AccordionServAcc.displayName = 'AccordionServAcc';

export default AccordionServAcc;
